/**
 * Mobile drawer: WelleCo-style sliding panels.
 * Converts <details> submenus into slide-in panels with a Back button.
 * Only activates at <= 1099px viewport.
 */
(function () {
  var MOBILE_BREAKPOINT = 1099;

  function isMobile() {
    return window.matchMedia('(max-width: ' + MOBILE_BREAKPOINT + 'px)').matches;
  }

  function getNavContainer() {
    return document.querySelector('.menu-drawer__navigation-container');
  }

  function injectBackButtons() {
    var details = document.querySelectorAll('.menu-drawer__navigation details');
    details.forEach(function (d) {
      var submenu = d.querySelector(':scope > .menu-drawer__submenu');
      if (!submenu) return;
      if (submenu.querySelector(':scope > .menu-drawer__back')) return;

      // Get the parent title from the summary
      var summary = d.querySelector(':scope > summary');
      var titleText = summary ? (summary.textContent || '').trim() : '';

      // Create back button with chevron SVG matching the forward arrows
      var back = document.createElement('button');
      back.type = 'button';
      back.className = 'menu-drawer__back';
      back.setAttribute('aria-label', 'Back');
      back.innerHTML =
        '<svg class="icon icon-arrow menu-drawer__back-arrow" width="8" height="14" viewBox="0 0 8 14" fill="none" xmlns="http://www.w3.org/2000/svg">' +
        '<path d="M7 13L1 7L7 1" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/></svg>' +
        '<span>Back</span>';

      function goBack(e) {
        if (e) { e.preventDefault(); e.stopPropagation(); }
        d.removeAttribute('open');
        updateActiveState();
      }
      back.addEventListener('click', goBack);

      // Panel title — make it clickable so the user can tap the whole
      // "< SHOP" row to go back (welleco-style nav). Customer fb: don't
      // show a separate "Back" button + heading; the heading IS the
      // back nav, with a prefixed arrow (handled by CSS ::before).
      var title = null;
      if (titleText) {
        title = document.createElement('h2');
        title.className = 'menu-drawer__panel-title';
        title.textContent = titleText;
        title.setAttribute('role', 'button');
        title.setAttribute('tabindex', '0');
        title.addEventListener('click', goBack);
        title.addEventListener('keydown', function (e) {
          if (e.key === 'Enter' || e.key === ' ') goBack(e);
        });
      }

      // Insert back + title at the top of the submenu
      submenu.insertBefore(back, submenu.firstChild);
      if (title) submenu.insertBefore(title, back.nextSibling);
    });
  }

  function updateActiveState() {
    var container = getNavContainer();
    if (!container) return;
    // Only consider TOP-LEVEL <details> (direct children of main menu ul)
    var topLevelOpen = container.querySelector('.menu-drawer__navigation > ul > li > details[open]');
    if (topLevelOpen && isMobile()) {
      container.classList.add('submenu-active');
    } else {
      container.classList.remove('submenu-active');
    }
  }

  function bindDetailsListeners() {
    var details = document.querySelectorAll('.menu-drawer__navigation details');
    details.forEach(function (d) {
      if (d.dataset.panelBound) return;
      d.dataset.panelBound = '1';
      d.addEventListener('toggle', updateActiveState);
    });
  }

  function initialize() {
    injectBackButtons();
    bindDetailsListeners();
    updateActiveState();
  }

  // Run when drawer content is ready
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initialize);
  } else {
    initialize();
  }

  // Re-run after Shopify section reloads
  document.addEventListener('shopify:section:load', function (e) {
    if (e.target && e.target.querySelector && e.target.querySelector('.menu-drawer')) {
      setTimeout(initialize, 100);
    }
  });

  // Reset panel state on resize if moving to desktop
  window.addEventListener('resize', function () {
    var container = getNavContainer();
    if (!container) return;
    if (!isMobile()) {
      container.classList.remove('submenu-active');
    } else {
      updateActiveState();
    }
  });

  // Close drawer handler — reset panel state so it's fresh next open
  document.addEventListener('click', function (e) {
    if (e.target.closest && e.target.closest('.header__icon--close, #menu-drawer-close, .menu-drawer-container > summary')) {
      setTimeout(function () {
        var container = getNavContainer();
        if (!container) return;
        container.querySelectorAll('details[open]').forEach(function (d) {
          d.removeAttribute('open');
        });
        container.classList.remove('submenu-active');
      }, 50);
    }
  });
})();
